import { useEffect, useState } from 'react';

const DEFAULT_DELAY = 600;

/* A chosen answer is marked first and submitted after a short delay (the way QuestionAnswerSlideV7 does it) */
function useAutoSubmitAnswer({ id, question, userResponse = {}, submitAnswer, submitTemporaryAnswer, delay = DEFAULT_DELAY }) {
    const [isPending, setIsPending] = useState(false);

    useEffect(() => {
        if (id) {
            setIsPending(false);
        }
    }, [id]);

    useEffect(() => {
        if (userResponse.id && userResponse.isPending) {
            setIsPending(true);

            const { isPending: isTemporaryPending, ...answerData } = userResponse; /* eslint-disable-line */

            const timeoutId = setTimeout(() => {
                submitAnswer(answerData)();
            }, delay);

            return () => clearTimeout(timeoutId);
        }
    }, [userResponse.id, userResponse.isPending]);

    const selectAnswer = answer => () => {
        if (isPending) {
            return;
        }

        submitTemporaryAnswer({ ...answer, answerIndex: answer.id - 1, questionId: id, question, isPending: true });
    };

    return { isPending, selectAnswer };
}

export {
    useAutoSubmitAnswer
};
